import script from "./WorkflowAggregatesProject.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAggregatesProject.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAggregatesProject.vue?vue&type=style&index=0&id=0646dc94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0646dc94"]])

export default __exports__